import { heroHighlights } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section id="top" className="relative min-h-[100svh] w-full flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20background%20of%20warm%20banana%20yellow%20and%20soft%20amber%20gradient%20waves%20with%20gentle%20light%20diffusion%2C%20smooth%20organic%20curves%2C%20subtle%20grain%20texture%2C%20calm%20minimalist%20composition%2C%20elegant%20editorial%20poster%20style%2C%20high%20resolution%2C%20no%20text%2C%20no%20people%2C%20harmonious%20warm%20tones&width=1920&height=1080&seq=banana-hero-wave-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-28 pb-20">
        <div className="max-w-5xl mx-auto text-center">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/15 border border-white/25 text-background-50 text-xs md:text-sm">
            <i className="ri-map-pin-2-line"></i>
            官网入口 · 网址首页 · 最新地址 · 新地址入口
          </span>

          <h1 className="mt-6 font-heading text-3xl sm:text-4xl md:text-6xl leading-tight text-background-50">
            香蕉社区最新地址
            <span className="block mt-2 text-2xl sm:text-3xl md:text-5xl text-primary-200">
              官网入口与网址首页一站查阅
            </span>
          </h1>

          <p className="mt-6 max-w-3xl mx-auto text-sm md:text-lg leading-relaxed text-background-100/90">
            本站汇总香蕉社区官网、网址、首页与最新地址，提供入口和新地址的说明与查找方式。
            需要访问时可直接查看，地址变动之后也能顺着清晰的指引重新找到可用入口。
          </p>

          <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#entrance"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-compass-3-line"></i>
              查看入口类型说明
            </a>
            <a
              href="#guide"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-white/10 border border-white/30 text-background-50 font-medium hover:bg-white/20 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-route-line"></i>
              安全访问五步走
            </a>
          </div>
        </div>

        <div className="max-w-5xl mx-auto mt-14 md:mt-20 grid grid-cols-1 sm:grid-cols-3 gap-4">
          {heroHighlights.map((item) => (
            <div
              key={item.title}
              className="rounded-lg bg-white/10 border border-white/20 backdrop-blur-sm p-5 md:p-6 text-left"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/90 text-background-50">
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <h2 className="mt-4 font-heading text-lg text-background-50">{item.title}</h2>
              <p className="mt-2 text-sm leading-relaxed text-background-100/85">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}